import makeSlice from '@web/slices/fds/sliceMaker'

const slice = makeSlice()

export default slice.reducer
